import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRuleParam,
  IIntegrationRuleParam,
} from "../models/integration-rule-param";

const INTEGRATION_RULE_PARAM_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleParam/";

export const createIntegrationRuleParam = (item: INewIntegrationRuleParam) => {
  return GlobalAxios.post(INTEGRATION_RULE_PARAM_ROUTE, item);
};

export const getIntegrationRuleParamById = (id: string) => {
  return GlobalAxios.get<IIntegrationRuleParam>(
    INTEGRATION_RULE_PARAM_ROUTE + id,
  );
};

export const updateIntegrationRuleParamById = ({
  item,
  id,
}: {
  item: INewIntegrationRuleParam;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_PARAM_ROUTE + id, item);
};
